export const LEGACY_CONFIRMATION = "VERIFY_PRODUCTS_IN_ILS";
export const LEGACY_SUCCESS_MESSAGE =
  "Update sent. Manual iLS Products verification is required.";

export function classifyHistoricalUpdateFallback(payload, selectedCount) {
  if (payload?.error === "historical_manual_verification_required" && selectedCount === 1) {
    const routingRowId = Number(payload?.row?.routingRowId);
    return Number.isFinite(routingRowId)
      ? { action: "PREVIEW", routingRowId }
      : { action: "ERROR", message: "Unable to identify the historical Routing Status row." };
  }
  if (payload?.error === "historical_manual_verification_single_row_required") {
    return {
      action: "ERROR",
      message: "Historical iLS updates require selecting one row at a time.",
    };
  }
  return { action: "NONE" };
}

export function isLegacySelectionEligible(rows) {
  return (
    Array.isArray(rows) &&
    rows.length === 1 &&
    String(rows[0]?.status ?? rows[0]?.Status ?? "").trim() === "Update"
  );
}

export function buildLegacyExecuteRequest(preview, riskAccepted, confirmation) {
  return {
    attemptId: preview?.attemptId,
    previewHash: preview?.previewHash,
    riskAccepted: riskAccepted === true,
    confirmation,
  };
}

async function requestJson(url, options) {
  const response = await fetch(url, options);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.ok !== true) {
    throw new Error(payload?.message || payload?.error || "Legacy iLS Update request failed.");
  }
  return payload;
}

export function previewLegacyIlsUpdate(apiBase, headers, routingRowId) {
  return requestJson(`${apiBase}/routing-status/ils-legacy-update/preview`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify({ routingRowId }),
  });
}

export function executeLegacyIlsUpdate(apiBase, headers, preview, riskAccepted, confirmation) {
  return requestJson(`${apiBase}/routing-status/ils-legacy-update/execute`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify(buildLegacyExecuteRequest(preview, riskAccepted, confirmation)),
  });
}

export function loadPendingLegacyIlsUpdates(apiBase, headers) {
  return requestJson(`${apiBase}/routing-status/ils-legacy-update/pending`, { headers });
}

export function verifyLegacyIlsUpdate(apiBase, headers, attemptId, result, verificationNote = "") {
  return requestJson(`${apiBase}/routing-status/ils-legacy-update/${attemptId}/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify({ result, verificationNote }),
  });
}
